import { FC, useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  Grid,
  MenuItem,
  CircularProgress,
  Avatar,
  Divider,
} from "@material-ui/core";
import { useTheme, TextField } from "@material-ui/core";
//import correct from "../../assets/images/icons/correct-24.svg";
//import coin from "../../assets/images/GAINFISH.svg";
//import copy from "../../assets/images/icons/copy.svg";
import ExpireLink from "../../assets/images/ExpireLinkIcon.svg";
import AlertContext from "../../store/Alert/AlertContext";
import { getSymbol } from "../../store/Wallet/WalletFunction";
import ContributionModal from "../Modals/ContributionModal";
import ConnectCorrectWallet from "../Modals/ConnectCorrectWallet";
import WalletContext from "../../store/Wallet/WalletContext";
import graphQLClient from "../../utils/authHeader";
import GET_POOL_WHITELIST_STATE from "../../utils/queries/pool/getPoolWhitelistState";
import { shorter } from "../../utils/web3/formatBalance";
import AuthContext from "../../store/Auth/AuthContext";
import { useAccount } from "wagmi";
import { useWalletConnect } from "../../services/web3/hooks/useWeb3";
import InvestCards, { InvestState } from "./InvestCard";
import WrongWallet from "./WrongWallet";
import InvestStyle from "./InvestStyle";
import MaxContribution from "./MaxContribution";

const InvestDetails: FC<any> = ({
  id,
  ticker,
  name,
  image,
  networks,
  allowedInvestment,
  stableCoinOption,
  balancesOption,
  usdPerTicketValue,
  code,
}) => {
  const theme = useTheme();
  const classes = InvestStyle();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));
  const { setAlert } = useContext<any>(AlertContext);
  const { isAuth } = useContext<any>(AuthContext);
  const { fetchContributed, isConnected } = useContext<any>(WalletContext);

  const [stableCoinSymbol, setStableCoinSymbol] = useState<string>("TUSDT");
  const [tokenBalance, settokenBalance] = useState<number>(0);
  const [openContributionModal, setOpenContributionModal] = useState(false);
  const [openConnectCorrectWalletModal, setOpenConnectCorrectWalletModal] =
    useState(false);
  const [contributionAmount, setContributionAmount] = useState<
    Record<string, number>
  >({});
  const [contributed, setContributed] = useState<Record<string, number>>({});
  const [whitelisted, setWhitelisted] = useState<Record<string, string>>({});
  const { address: account, chain } = useAccount();
  const { openConnectModal } = useWalletConnect();
  const [options, setOptions] = useState<Record<string, number[]>>({});
  const [fetching, setFetching] = useState(false);
  const [symbol, setSymbol] = useState<string | null>(null);
  const [poolWhitelistState, setWhitelistPoolState] = useState<any>(null);
  const [maxContributed, toggleMaxContributed] = useState<boolean>(false);

  const [contributionCardState, setContributionCardState] =
    useState<InvestState | null>();
  const [showContributionCardPopup, setShowContributionCardPopup] =
    useState(false);

  useEffect(() => {
    if (contributionCardState) {
      setShowContributionCardPopup(true);
    }
  }, [contributionCardState]);

  const Expire = () => {
    return <img src={ExpireLink} className="img-fluid imageAlign" />;
  };

  const investDisabled = (
    _networkId: string,
    _address: string,
    _contributed: Record<string, number>,
    _contribution: Record<string, number>,
    _allowedInvestment: number,
    _tokenBalance: number,
    _whitelisted: string,
    _account: `0x${string}` | undefined,
    _insufficientBalanceDisable = true,
  ) => {
    if (!isAuth) return true;
    if (!_account) return false;
    if (Object.keys(_contributed).length === 0) return true;
    if (
      _contributed[`${_address}-${_networkId}`] &&
      _contributed[`${_address}-${_networkId}`] === _allowedInvestment
    ) {
      toggleMaxContributed(true);
      return true;
    }

    if (
      _contribution[`${_address}-${_networkId}`] &&
      _contribution[`${_address}-${_networkId}`] > _allowedInvestment
    )
    {
      toggleMaxContributed(true);
      return true;
    }

    if (
      _contribution[`${_address}-${_networkId}`] &&
      _contribution[`${_address}-${_networkId}`] > _tokenBalance && _insufficientBalanceDisable
    )
      return true;

    if (
      _whitelisted &&
      _account &&
      _whitelisted.toLowerCase() !== _account.toLowerCase()
    )
      return true;

    return false;
  };

  const getContributions = (address: string) => {
    const configs = networks.map((network: any) => {
      return {
        address: network.address,
        networkId: network.networkId,
      };
    });
    setFetching(true);
    fetchContributed(configs, address)
      .then((res: any) => {
        setContributed(res);
        const remainingBalanceMap: Record<string, number[]> = {};
        const _maxContributeAmount: Record<string, number> = {};
        const cappedContribution: Record<string, number> = {};
        for (const config of configs) {
          const key = `${config.address}-${config.networkId}`;
          const contributedAmount = res[key] || 0;
          const remainingAmount = allowedInvestment - contributedAmount;

          const _options: number[] = [];
          for (
            let i = usdPerTicketValue;
            i <= remainingAmount;
            i += usdPerTicketValue
          ) {
            _options.push(i);
          }
          remainingBalanceMap[key] = _options;
          _maxContributeAmount[key] = _options[_options.length - 1] || 0;
          const maxByBalance =
            Math.floor(tokenBalance / usdPerTicketValue) * usdPerTicketValue;
          cappedContribution[key] =
            maxByBalance > 0
              ? Math.min(_maxContributeAmount[key], maxByBalance)
              : 0;
        }

        setOptions(remainingBalanceMap);
        setContributionAmount(cappedContribution);
        setFetching(false);
      })
      .catch((e: any) => {
        console.error(e);
        setAlert(
          "Unable to read contributions from the chain, please try again.",
          "error"
        );
        setFetching(false);
      });
  };

  useEffect(() => {
    if (poolWhitelistState && poolWhitelistState.address)
      getContributions(poolWhitelistState.address);
  }, [poolWhitelistState]);

  useEffect(() => {
    const fetchWhitelisted = async () => {
      const configs = networks?.map((network: any) => {
        return {
          poolId: id,
          networkId: network.networkId,
        };
      });

      const _whitelisted: Record<string, string> = {};
      for (const config of configs) {
        try {
          const response = await graphQLClient.request(
            GET_POOL_WHITELIST_STATE,
            config
          );
          _whitelisted[`${config.networkId}`] =
            response.getPoolWhitelistState.address;
          let symbol = await getSymbol(
            response.getPoolWhitelistState.networkId,
            response.getPoolWhitelistState.token
          );
          setSymbol(symbol);
          setWhitelistPoolState(response.getPoolWhitelistState);
        } catch (e) {
          
          setAlert("Unable to fetch pool whitelist state", "error");
        }
      }

      setWhitelisted(_whitelisted);
    };

    fetchWhitelisted();
  }, []);

  const text = useRef<any>();

  useEffect(() => {
    setStableCoinSymbol(stableCoinOption[0]);
    settokenBalance(balancesOption[0]);
  }, [stableCoinOption, balancesOption]);

  const copytext = async (event: any) => {
    event.preventDefault();
    navigator.clipboard.writeText(text.current.value);
    setAlert("Copied!!", "success");
  };

  const handleChange = (event: any) => {
    setStableCoinSymbol(event.target.value);
    let index = stableCoinOption.indexOf(event.target.value);
    settokenBalance(balancesOption[index]);
  };

  const handleContributionModal = () => {
    setOpenContributionModal(true);
  };

  const handleConnectCorrectWalletModal = () => {
    setOpenConnectCorrectWalletModal(true);
  };

  const handleConnectWallet = (event: any) => {
    event.preventDefault();
    if (openConnectModal) openConnectModal();
  };

  const handleContribution = () => {
    getContributions(poolWhitelistState?.address);
  };

  const handleDismissConnectWallet = () => {
    setOpenConnectCorrectWalletModal(false);
  };
  /*
whitelisted[`${network.networkId}`]?.toLowerCase() ===
                  account?.toLowerCase()
                  */
  return (
    <Box style={{ position: isActive ? "relative" : "static" }}>
      {networks?.map((network: any) => (
        <Box
        >
          {
            (account && Object.keys(whitelisted).length > 0  && whitelisted[`${network.networkId}`]?.toLowerCase() !== account?.toLowerCase()) 
            ? (
              <Box >
                <WrongWallet address={whitelisted[`${network.networkId}`]} />
              </Box>
              )
            :
              maxContributed
                ?
                  (
                    <Box>
                      <MaxContribution />
                    </Box>
                  )
                :
                  <Grid        
                    container
                    direction="column"
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    style={{
                      marginTop: "1rem",
                      display: "block",
                    }}
                  >
                    <Grid item>
                      {!isActive && (
                        <Grid container direction="row" alignItems="center" spacing={2}>
                          <Grid item>
                            <Avatar
                              variant="circle"
                              src={image}
                              style={{
                                border: "1px solid rgba(232, 234, 234, 1)",
                                borderRadius: "50%",
                                padding: "2px",
                                objectFit: "cover",
                              }}
                            />
                          </Grid>
                          <Grid item>
                            <Typography
                              variant="h3"
                              style={{
                                color: "rgba(17, 48, 45, 1)",
                              }}
                            >
                              {name}{" "}
                              <span
                                style={{
                                  color: "rgba(140, 162, 183, 1)",
                                }}
                              >
                                {`(${ticker})`}
                              </span>
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    <Grid
                      item
                      style={{
                        margin: "20px 0px 20px 0px",
                      }}
                    >
                      <Divider
                        style={{
                          background: "rgba(140, 162, 183, 1)",
                          opacity: "10%",
                        }}
                      />
                    </Grid>
                    <Grid item>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="h4">Invest</Typography>
                    <Typography
                      variant="caption"
                      style={{
                        fontSize: "12px",
                        color: "rgba(65, 89, 87, 1)",
                        fontWeight: 400,
                        lineHeight: 1.5,
                      }}
                    >
                      ( Max cap{" "}
                      <span style={{ color: "rgba(62, 184, 170, 1)" }}>
                        {allowedInvestment} {symbol}
                      </span>
                      {"  /  "}Contributed{" "}
                      <span style={{ color: "rgba(62, 184, 170, 1)" }}>
                        {contributed[`${network.address}-${network.networkId}`] ??
                          0}{" "}
                        {symbol}
                      </span>
                      {"  /  "}Balance{" "}
                      <span style={{ color: "rgba(62, 184, 170, 1)" }}>
                        {tokenBalance ?? 0} {symbol}
                      </span>
                      )
                    </Typography>
                  </Box>
                      <Box>
                        <TextField
                          name="invest"
                          type="number"
                          placeholder={code ? "Enter amount" : "Loading..."}
                          margin="dense"
                          fullWidth
                          defaultValue={
                            contributionAmount[
                              `${network.address}-${network.networkId}`
                            ] ?? (allowedInvestment > tokenBalance ? Math.floor(tokenBalance / usdPerTicketValue) * usdPerTicketValue : allowedInvestment)
                          }
                          value={
                          contributionAmount[
                            `${network.address}-${network.networkId}`
                          ] ??
                          (allowedInvestment > tokenBalance
                            ? Math.floor(tokenBalance / usdPerTicketValue) *
                              usdPerTicketValue
                            : allowedInvestment)
                          }
                          onChange={(event: any) => {
                            const v = Number(event.target.value);
                            const _contributionAmount = { ...contributionAmount };
                            _contributionAmount[
                              `${network.address}-${network.networkId}`
                            ] = v;
                            setContributionAmount(_contributionAmount);
                          }}
                          variant="outlined"
                          select={!code} 
                          SelectProps={{
                            MenuProps: {
                              PaperProps: {
                                style: {
                                  overflowY: 'auto',
                                  overflowX: 'hidden',
                                }
                              }
                            }
                          }}
                        >
                    {fetching ? (
                      <CircularProgress size={20} />
                    ) : (
                      (() => {
                        const key = `${network.address}-${network.networkId}`;
                        const list = options[key] || [];

                        const maxByBalance =
                          Math.floor(tokenBalance / usdPerTicketValue) *
                          usdPerTicketValue;

                        const items = list
                          .filter(
                            (v) => v <= maxByBalance || maxByBalance === 0
                          )
                          .map((option: number) => (
                            <MenuItem key={option} value={option}>
                              {option}
                              {contributed[key] &&
                              contributed[key] + option === allowedInvestment &&
                              allowedInvestment <= tokenBalance
                                ? " MAX"
                                : ""}
                            </MenuItem>
                          ));
                        if (maxByBalance > 0 && !list.includes(maxByBalance)) {
                          items.push(
                            <MenuItem
                              key={`tb-${maxByBalance}`}
                              value={maxByBalance}
                            >
                              {maxByBalance} Total Balance
                            </MenuItem>
                          );
                        }

                        return fetching ? (
                          <CircularProgress size={20} />
                        ) : (
                          items
                        );
                      })()
                    )}
                    </TextField>
                      </Box>
                      <Box>
                        <Button
                          variant="contained"
                          className={`btn-medium ${classes.investBtn}`}
                          fullWidth
                          onClick={async (event) => {
                            if (
                              contributed[`${network.address}-${network.networkId}`] &&
                              contributed[`${network.address}-${network.networkId}`] ===
                                allowedInvestment
                            ) {
                              // nothing
                              console.log("investing.....");
                            } else if (!account || !isConnected) {
                              handleConnectWallet(event);
                            } else if (chain?.id !== Number(network.networkId)) {
                              handleConnectCorrectWalletModal();
                            } else {
                              const amount = contributionAmount[`${network.address}-${network.networkId}`];

                            if (!amount || isNaN(amount) || amount <= 0) {
                              setAlert("Invalid contribution amount", "error");
                              return;
                            }
                              handleContributionModal();
                            }
                          }}
                          disabled={investDisabled(
                            network.networkId,
                            network.address,
                            contributed,
                            contributionAmount,
                            allowedInvestment,
                            tokenBalance,
                            whitelisted[`${network.networkId}`],
                            account
                          )}
                        >
                          {" "}
                          {!isAuth
                            ? "Login"
                            : !isConnected || !account
                            ? "Connect Wallet"
                            : "Invest Now"}{" "}
                        </Button>
                        {contributionAmount[
                          `${network.address}-${network.networkId}`
                        ] &&
                        whitelisted[`${network.networkId}`]?.toLowerCase() ===
                          account?.toLowerCase() &&
                        contributionAmount[`${network.address}-${network.networkId}`] >
                          tokenBalance ? (
                          <Box textAlign="center">
                            <span className="error ml-8 mt-4">
                              You cannot invest more than your current {symbol} balance.
                            </span>
                          </Box>
                        ) : (
                          ""
                        )}
                        {whitelisted[`${network.networkId}`] &&
                          account &&
                          whitelisted[`${network.networkId}`].toLowerCase() !==
                            account.toLowerCase() && (
                            <Box textAlign="center">
                              <span className="error ml-8 mt-4">
                                {`Please connect the wallet ${shorter(
                                  whitelisted[`${network.networkId}`]
                                )} to continue with investment`}
                              </span>
                            </Box>
                          )}
                        {openContributionModal && (
                          <ContributionModal
                            open={openContributionModal}
                            setOpen={setOpenContributionModal}
                            contributionCurrency={stableCoinSymbol}
                            contributionAmount={
                              contributionAmount[
                                `${network.address}-${network.networkId}`
                              ]
                            }
                            maxAllowed={allowedInvestment}
                            contractAddress={network.address}
                            tokenAddress={network.token}
                            poolId={id}
                            networkId={network.networkId}
                            usdPerTicketValue={usdPerTicketValue}
                            handleContribution={handleContribution}
                            setContributionCardState={setContributionCardState}
                          />
                        )}
                        {openConnectCorrectWalletModal && (
                          <ConnectCorrectWallet
                            open={openConnectCorrectWalletModal}
                            setOpen={setOpenConnectCorrectWalletModal}
                            connectWallet={handleConnectWallet}
                            dismissConnectWallet={handleDismissConnectWallet}
                            poolId={id}
                            networkId={network.networkId}
                          />
                        )}
                        {showContributionCardPopup && (
                          <InvestCards
                            open={showContributionCardPopup}
                            setOpen={setShowContributionCardPopup}
                            state={contributionCardState}
                          />
                        )}
                      </Box>
                    </Grid>
                  </Grid>
          }
        </Box>
      ))}
    </Box>
  );
};

export default InvestDetails;
